import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { PromotionSystem } from '../../../models/promotion-system.model';
import { PromotionSystemService } from '../../../services/promotion-system/promotion-system.service';

@Component({
  selector: 'app-promotion-system-form',
  templateUrl: 'promotion-systemForm.html',
  styles: [
    'label.required:after {top: 0}',
    'input[type="file"] {display: none;}',
    '#img-container {position: relative;}',
    '#remove-img-btn {width: 25px !important; height: 25px !important; position: absolute; bottom: 0; left: 90px; border-radius: 100%;}',
    '.drag {width: 100%; padding: 8px; text-align: center; border: 1px dashed #cccccc; border-radius: 4px; cursor: pointer;}',
    '.icon-upload {font-size: 26px; padding-top: 6px; padding-bottom: 4px; color: #999999;}',
    '.drag-description {font-size: 12px; color: #999999;}',
    '::ng-deep .ui-fileupload-buttonbar {display: none;}'
  ]
})

export class PromotionSystemFormComponent implements OnInit {
  recordId: any;
  editMode = false;
  item: PromotionSystem = new PromotionSystem();
  addEditForm: FormGroup;
  public fields: any;
  public invalidSubmit: boolean;
  newImgType: string;

  constructor(
    private fb: FormBuilder,
    private srvNotify: MessageService,
    private translateService: TranslateService,
    private srv: PromotionSystemService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  get f() {
    return this.addEditForm.controls;
  }

  get previewSrc(): string {
    if (this.addEditForm && this.addEditForm.get('img_b64').value) {
      return this.addEditForm.get('img_b64').value;
    }
    return (this.addEditForm && this.addEditForm.get('img_url').value) || '';
  }

  get hasImage(): boolean {
    return !!(this.previewSrc);
  }

  ngOnInit() {
    this.srv.getFields().subscribe(res => {
      this.fields = res;
    });

    this.recordId = this.route.snapshot.params['id'];
    this.editMode = this.recordId !== undefined && this.recordId !== null;

    this.buildForm();

    if (this.editMode) {
      const editing = this.srv.itemEditing;
      if (editing && Number(editing.id) === Number(this.recordId)) {
        this.applyRecord(editing);
      } else {
        this.srv.getById(this.recordId).subscribe(res => {
          const record = Array.isArray(res) ? res[0] : res;
          if (record) {
            this.applyRecord(record);
          }
        });
      }
    }
  }

  private buildForm() {
    this.addEditForm = this.fb.group({
      'code': new FormControl(this.item.code, Validators.maxLength(10)),
      'name': new FormControl(this.item.name, Validators.maxLength(255)),
      'description': new FormControl(this.item.description, Validators.maxLength(255)),
      'img_b64': new FormControl(this.item.img_b64),
      'img_url': new FormControl(this.item.img_url)
    });
  }

  private applyRecord(record: any) {
    this.item = Object.assign(new PromotionSystem(), record);
    this.addEditForm.patchValue({
      code: record.code,
      name: record.name,
      description: record.description,
      img_b64: record.img_b64 || null,
      img_url: record.img_url || null
    });
  }

  uploadImg(files?: FileList) {
    if (!files || files.length === 0) {
      return;
    }
    const reader = new FileReader();
    this.newImgType = files[0].type;
    reader.onload = this.handleReaderLoaded.bind(this);
    reader.readAsBinaryString(files[0]);
  }

  handleReaderLoaded(e) {
    const newBase64Img = btoa(e.target.result);
    if (newBase64Img) {
      this.f.img_url.setValue(null);
      this.f.img_b64.setValue(`data:${this.newImgType};base64,${newBase64Img}`);
    }
  }

  removeImage() {
    this.f.img_b64.setValue(null);
    this.f.img_url.setValue(null);
  }

  goBack(): void {
    this.router.navigate(['/promotions']);
  }

  save(): void {
    if (!this.addEditForm.valid) {
      this.invalidSubmit = true;
      return;
    }
    this.invalidSubmit = false;
    const formValue = this.addEditForm.value;
    const newData = {
      ...this.item,
      ...formValue,
      img_url: formValue.img_b64 ? null : (formValue.img_url || null)
    };
    if (this.editMode) {
      this.srv.put(newData, true).subscribe(
        () => {
          this.srv.itemEditing = null;
          this.router.navigate(['/promotions']);
        },
        (err) => this.handleSaveError(err)
      );
    } else {
      this.srv.post(newData, true).subscribe(
        () => {
          this.router.navigate(['/promotions']);
        },
        (err) => this.handleSaveError(err)
      );
    }
  }

  private handleSaveError(err: any): void {
    console.error(err);
    const message = typeof err === 'string' ? err : (err && err.message) || '';
    if (message.indexOf('CodeAlreadyExists') !== -1) {
      this.f.code.setErrors({ codeExists: true });
      this.srvNotify.add({
        severity: 'error',
        summary: this.translateService.instant('common.error'),
        detail: this.translateService.instant('common.codeAlreadyExists')
      });
    } else {
      this.srvNotify.add({
        severity: 'error',
        summary: this.translateService.instant('common.error'),
        detail: message
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/promotion-system/promotion-systemForm.component.ts